<a class="contact-email" title="Send an email to the curators" href="{{emailLink}}">{{linkName}}</a>
